import { render, staticRenderFns } from "./Stakeholders.vue?vue&type=template&id=9fb691d2&scoped=true"
import script from "./Stakeholders.vue?vue&type=script&lang=js"
export * from "./Stakeholders.vue?vue&type=script&lang=js"
import style0 from "./Stakeholders.vue?vue&type=style&index=0&id=9fb691d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb691d2",
  null
  
)

export default component.exports